import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';

@Injectable()

export class AnnualPlanEndpoint extends EndpointFactory {
  private readonly getOrganizationsEndpointPath: string = "/api/prioritySubmissionService/getOrganizations";
  private readonly getRtrApplicablesEndpointPath: string = "/api/prioritySubmissionService/getRtrApplicables";
  private readonly getDepartmentsEndpointPath: string = "/api/regulatoryItemService/getDepartments";
  private readonly getPrioritySubmissionItemTypesEndpointPath: string = "/api/prioritySubmissionService/getPrioritySubmissionItemTypes";
  private readonly getIndustryPanelsEndpointPath: string = "/api/prioritySubmissionService/getIndustryPanels";
  private readonly getSubmissionStatusEndpointPath: string = "/api/prioritySubmissionService/getSubmissionStatus";
  private readonly getPrioritySubmissionThemesEndpointPath: string = "/api/prioritySubmissionService/getPrioritySubmissionThemes";
  private readonly getAllAnnualPlanItemsEndpointPath: string = "/api/annualPlanItemService/getAllAnnualPlanItems";
  private readonly getAnnualPlanItemsByPrioritySubmissionEndpointPath: string = "/api/annualPlanItemService/getAnnualPlanItemsByPrioritySubmission";
  private readonly getPrioritySubmissionEndpointPath: string = "/api/prioritySubmissionService/getPrioritySubmission";
  private readonly createPrioritySubmissionEndpointPath: string = "/api/prioritySubmissionService/createPrioritySubmission";
  private readonly fileUploadEndpointPath: string = "/api/annualPlanItemService/uploadAnnualPlanDocument";
  private readonly helpFileUploadEndpointPath: string = "/api/prioritySubmissionService/helpFileUpload";
  private readonly fileDownloadEndpointPath: string = "/api/prioritySubmissionService/downloadFile";
  private readonly helpFileDownloadEndpointPath: string = "/api/prioritySubmissionService/getFileUploadByName";
  private readonly importLegislationRegulatoryItemsEndpointPath: string = "/api/prioritySubmissionService/importLegislationRegulatoryItems";
  private readonly importAgencyRegulatoryItemsEndpointPath: string = "/api/prioritySubmissionService/importAgencyRegulatoryItems";
  private readonly getAnnualPlanYearsEndpointPath: string = "/api/ref/getAnnualPlanYears";
  private readonly getAnnualPlanScheduledContinuingsEndpointPath: string = "/api/ref/getAnnualPlanScheduledContinuings";
  private readonly getAnnualPlanItemStatusEndpointPath: string = "/api/ref/getAnnualPlanItemStatus";
  private readonly getSessionsEndpointPath: string = "/api/ref/getSessions";
  private readonly submitAnnualPlanItemEndpointPath: string = "/api/annualPlanItemService/submitAnnualPlanItem";
  private readonly submitOrganizationEndpointPath: string = "/api/annualPlanItemService/submitOrganization";
 

  get getOrganizationsEndpointUrl() { return this.configurations.baseUrl + this.getOrganizationsEndpointPath; }
  get getRtrApplicablesEndpointUrl() { return this.configurations.baseUrl + this.getRtrApplicablesEndpointPath; }
  get getDepartmentsEndpointUrl() { return this.configurations.baseUrl + this.getDepartmentsEndpointPath; }
  get getPrioritySubmissionItemTypesEndpointUrl() { return this.configurations.baseUrl + this.getPrioritySubmissionItemTypesEndpointPath; }
  get getIndustryPanelsEndpointUrl() { return this.configurations.baseUrl + this.getIndustryPanelsEndpointPath; }
  get getSubmissionStatusEndpointUrl() { return this.configurations.baseUrl + this.getSubmissionStatusEndpointPath; }
  get getPrioritySubmissionThemesEndpointUrl() { return this.configurations.baseUrl + this.getPrioritySubmissionThemesEndpointPath; }
  get getAllAnnualPlanItemsEndpointUrl() { return this.configurations.baseUrl + this.getAllAnnualPlanItemsEndpointPath; }
  get getAnnualPlanItemsByPrioritySubmissionEndpointUrl() { return this.configurations.baseUrl + this.getAnnualPlanItemsByPrioritySubmissionEndpointPath; }
  get getPrioritySubmissionEndpointUrl() { return this.configurations.baseUrl + this.getPrioritySubmissionEndpointPath; }
  get submitAnnualPlanItemEndpointUrl() { return this.configurations.baseUrl + this.submitAnnualPlanItemEndpointPath; }
  get createPrioritySubmissionEndpointUrl() { return this.configurations.baseUrl + this.createPrioritySubmissionEndpointPath; }
  get fileUploadEndpointUrl() { return this.configurations.baseUrl + this.fileUploadEndpointPath; }
  get helpFileUploadEndpointPathEndpointUrl() { return this.configurations.baseUrl + this.helpFileUploadEndpointPath; }
  get fileDownloadEndpointUrl() { return this.configurations.baseUrl + this.fileDownloadEndpointPath; }
  get helpFileDownloadEndpointUrl() { return this.configurations.baseUrl + this.helpFileDownloadEndpointPath; }
  get importLegislationRegulatoryItemsEndpointUrl() { return this.configurations.baseUrl + this.importLegislationRegulatoryItemsEndpointPath; }
  get importAgencyRegulatoryItemsEndpointUrl() { return this.configurations.baseUrl + this.importAgencyRegulatoryItemsEndpointPath; }
  get getAnnualPlanYearsEndpointUrl() { return this.configurations.baseUrl + this.getAnnualPlanYearsEndpointPath; }
  get getAnnualPlanScheduledContinuingsEndpointUrl() { return this.configurations.baseUrl + this.getAnnualPlanScheduledContinuingsEndpointPath; }
  get getAnnualPlanItemStatusEndpointUrl() { return this.configurations.baseUrl + this.getAnnualPlanItemStatusEndpointPath; }
  get getSessionsEndpointUrl() { return this.configurations.baseUrl + this.getSessionsEndpointPath; }
  get submitOrganizationEndpointUrl() { return this.configurations.baseUrl + this.submitOrganizationEndpointPath; }

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }

  getOrganizations<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getOrganizationsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getRtrApplicables<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getRtrApplicablesEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getDepartments<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getDepartmentsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getPrioritySubmissionItemTypes<T>(): Observable<T> {
    let endpointUrl = `${this.getPrioritySubmissionItemTypesEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  getIndustryPanels<T>(): Observable<T> {
    let endpointUrl = `${this.getIndustryPanelsEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  getSubmissionStatus<T>(): Observable<T> {
    let endpointUrl = `${this.getSubmissionStatusEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  getPrioritySubmissionThemes<T>(): Observable<T> {
    let endpointUrl = `${this.getPrioritySubmissionThemesEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  getAnnualPlanYears<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getAnnualPlanYearsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAnnualPlanScheduledContinuings<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getAnnualPlanScheduledContinuingsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAnnualPlanItemStatus<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getAnnualPlanItemStatusEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getSessions<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getSessionsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAnnualPlanItem<T>(annualPlanItemID?: string, userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getPrioritySubmissionEndpointUrl}/${annualPlanItemID}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAllAnnualPlanItems<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getAllAnnualPlanItemsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAllAnnualPlanItemsByYear<T>(userProfileID?: string, annualPlanYearVldID?: number): Observable<T> {
    let endpointUrl = `${this.getAllAnnualPlanItemsEndpointUrl}/${userProfileID}/${annualPlanYearVldID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAnnualPlanItemsByPrioritySubmission<T>(prioritySubmissionId?: string): Observable<T> {
    let endpointUrl = `${this.getAnnualPlanItemsByPrioritySubmissionEndpointUrl}/${prioritySubmissionId}`;
    return this.http.get<T>(endpointUrl);
  }


  createPrioritySubmission<T>(): Observable<T> {
    let endpointUrl = `${this.createPrioritySubmissionEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  submitAnnualPlanItem<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.submitAnnualPlanItemEndpointUrl}/`;
    //console.log(this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders()));
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }

  submitOrganization<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.submitOrganizationEndpointUrl}/`;
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }
  
  async uploadExternalDocument(formData: any) {
    let endpointUrl = `${this.fileUploadEndpointUrl}/`;
    return await this.http.post(endpointUrl, formData, { reportProgress: true, observe: 'events' }).toPromise();
  }

  downloadFile(externalDocumentID: string, fileName: string): Observable<Blob> {
    let endpointUrl = `${this.fileDownloadEndpointUrl}/${externalDocumentID}/${fileName}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }
  
}
